import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP: src/lib/llm/map-reduce/index.ts +
// src/lib/workflows/smart-process/index.ts + the 2026-05-22 auto-split design doc/VC.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "One workflow step. Same instruction. But it picks a cheap model or a strong one — by itself." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, holdSec: 6.5, caption: "Default move: throw the whole big input at one giant model call." },
  { scene: "problem", fromSec: 7, holdSec: 6.5, caption: "It costs more as context grows, it's slower, and it gets lost in the middle." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.4, holdSec: 5.5, caption: "Depth comes from architecture, not a bigger model." },
  { scene: "intuition", fromSec: 6.2, holdSec: 5.5, caption: "Small input? Ask once. Big input? Split it, then fuse — automatically." },
];

export const ROUTE: ScriptLine[] = [
  { scene: "route", fromSec: 0.4, holdSec: 6, caption: "No router LLM — control flow by prompt is flaky. The route is a deterministic threshold." },
  { scene: "route", fromSec: 6.5, holdSec: 6.5, caption: "Over ~6,000 estimated tokens, or more than 8 items, it splits. Otherwise: one call." },
];

export const PIPELINE: ScriptLine[] = [
  { scene: "pipeline", fromSec: 0.4, holdSec: 6, caption: "Split the input into ~3,000-token chunks, never mid-item." },
  { scene: "pipeline", fromSec: 6.5, holdSec: 6.5, caption: "Run a cheap model on every chunk in parallel — the map. Then one strong model fuses them — the reduce." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "decideRoute is pure: estimate tokens by chars over four, compare to the thresholds." },
  { scene: "code", fromSec: 7.5, holdSec: 7, caption: "Map tier resolves to the generation model — Gemini Flash. Reduce and single resolve to the deep tier — Gemini 2.5 Pro." },
  { scene: "code", fromSec: 15, holdSec: 7.5, caption: "If every map call fails it throws — it never marks the step done on silence." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.4, holdSec: 6, caption: "Mixture-of-Agents: many cheap parallel proposers plus one strong aggregator beat a single expensive model." },
  { scene: "payoff", fromSec: 6.7, holdSec: 6.5, caption: "And it's invisible — the step says compare and merge. No flag, no toggle, no prompt about splitting." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Don't reach for a bigger model. Reach for a better shape — and let the engine pick it." },
  { scene: "outro", fromSec: 5.8, holdSec: 4, caption: "Next: how an automated task quietly burned $55 in five days — and the guardrails." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
